import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { Banner } from 'commons/models/banner.model';
import { AppContext, getClonedData } from 'commons-ui';

import { FORM_FIELD_KEYS } from '../../utils/formConfig';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { UserlistData } from '../../utils/constants';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const data = _get(location, ['state', 'rowData']);
	const { requestCreateUserSegment, requestCreateBanner } = useService();

	const cloneBanner = (clonedData: { bannerData: Banner; userListData?: UserlistData }) => {
		setShowLoader(true);
		const { bannerData, userListData } = clonedData;

		requestCreateBanner(app.appName, { ...bannerData, isGold: app.isGold, isActive: false }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the banner', { type: 'error' });
					setShowLoader(false);
					return;
				}

				if (userListData) {
					requestCreateUserSegment(app.appName, userListData).then((userRes: any) => {
						if (userRes.status !== 200 || !userRes.data.success) {
							showAlert(
								`Error: Banner was successfully created. Error occured while creating user segment. Please edit the banner to create the segment again`,
								{ type: 'error' }
							);
						} else {
							showAlert('Banner created');
						}
						setShowLoader(false);
						history.goBack();
					});
				} else {
					showAlert('Banner created');
					setShowLoader(false);
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		cloneBanner(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateFormData(getClonedData(data, FORM_FIELD_KEYS)),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
